import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import permissionSlice from './slices/permissionSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    permissions: permissionSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const selectAuth = state => state.auth;
